module.exports = __webpack_public_path__ + "img/icon_nav-arrow.617363e3.svg";